export default __webpack_public_path__ + "static/media/path-of-brew-sm.0b96cf2c.png";